// removed by extract-text-webpack-plugin
module.exports = {"stickyWrapper":"OMTfwu-OhSGnWkkCRvgtA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/StickySection/StickySection.scss
// module id = 1706
// module chunks = 0